<template>
  <div>
    <div>
      <div class="history">
        <el-link type="primary" @click="historydialogVisible=true">History List</el-link>
        <el-link type="primary" style="margin-left:30px" @click="logOutdialogVisible=true">Logout</el-link>

      </div>
        <el-dialog title="" :visible.sync="logOutdialogVisible" width="30%">
      <span>Are you sure you want to log out</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logOutdialogVisible = false">No</el-button>
        <el-button type="primary" @click="Logout()">Yes</el-button>
      </span>
    </el-dialog>
      <!-- 历史列表 -->
      <el-dialog title="History List" :visible.sync="historydialogVisible" width="90%">
        <el-table :data="HistoryList" style="width: 100%" v-loading="loading" border >
          <el-table-column type="index" width="50" align="center">
          </el-table-column>
          <el-table-column prop="id" label="ID" width="80px"  align="center">
          </el-table-column>
             <el-table-column prop="rfqId" label="Rfq Id" width="120px"  align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="quotationName" label="Name" width="120px"  align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="clientName" label="Client Name" width="130px"  align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="optionUserName" label="Option Client Name" width="170px" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="updateTime" label="Update Time"  align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="createTime" label="Create Time" align="center" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="projectType" label="Project Type" align="center" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination background layout="prev, pager, next" :current-page="pageIndex" :page-size="pageSize" :total="allCount" @current-change="getQuotationList">
          </el-pagination>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="historydialogVisible = false">OK</el-button>
        </span>
      </el-dialog>
      <div class="projectform">
        <el-form :rules="formrules" ref="form" :model="form" label-width="auto">
          <div style="display:flex">
            <el-form-item label="Project Name" prop="name">
              <el-input v-model="form.name" type="textarea" autosize></el-input>
            </el-form-item>
            <el-form-item class="company" v-if="!disabled">
              <el-select v-model="form.client" :disabled="disabled" placeholder="请选择">
                <el-option v-for="item in clientList" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="Methods">
            <el-radio-group v-model="form.resource" @input="show()">
              <el-radio :label="1">Quantitative Only</el-radio>
              <el-radio :label="2">Qualitative Only</el-radio>
              <el-radio :label="3">Both</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>

      <div class="information">
        <div class="quant" v-show="quantvisible">
          <div class="form">
            <el-tag class="title">Quantitative</el-tag>
            <div class="method">Method: online survey</div>
            <el-form :rules="rules" ref="quant" :model="quant" label-width="80px" label-position="left">
              <!-- market -->
              <!-- <el-form-item label="Market" prop="quantmarket">
                <el-select v-model="quant.market" multiple placeholder="Add a Market" @change="copy">
                  <el-option v-for="item in marketlist" :key="item.id" :label="item.nameEN" :value="item.id">
                  </el-option>
                </el-select>
                <el-tooltip class="item" effect="dark" content="If there are more than 1 market for this project, you can add them all here." placement="right">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </el-form-item> -->
              <!-- market -->
              <el-form-item label="Market" prop="quantmarket">
                <div>
                  <div v-for="(tag,index) in quantMarketdynamicTags">
                    <el-tag closable :disable-transitions="false" @close="quantMarkethandleClose(tag)">
                      {{tag.value}}
                    </el-tag>
                  </div>
                  <el-autocomplete placeholder="Add a Market" class="input-new-tag" :trigger-on-focus="true" @select="MarkethandleInputConfirm" @keyup.enter.native="noMarkethandleInputConfirm" :fetch-suggestions="MarketquerySearch" v-model="quantMarketinputValue">
                  </el-autocomplete>
                  <el-tooltip class="item" effect="dark" content="If there are more than 1 market for this project, you can add them all here." placement="right">
                    <i class="el-icon-info"></i>
                  </el-tooltip>

                </div>

              </el-form-item>
              <!-- target -->
              <el-form-item label="Target" prop="quanttarget">
                <div>
                  <div v-for="(tag,index) in quantdynamicTags" :key="index+'t'">
                    <el-tag closable :disable-transitions="false" @close="handleClose(tag)">
                      {{tag.value}}
                    </el-tag>
                  </div>

                  <!-- <el-autocomplete class="inline-input" v-model="quantstate" :fetch-suggestions="querySearch" placeholder="请输入内容" :trigger-on-focus="false" @select="handleSelect"></el-autocomplete> -->
                  <el-autocomplete placeholder="Add a Target" class="input-new-tag" :trigger-on-focus="true" @select="handleInputConfirm" @keyup.enter.native="nohandleInputConfirm" :fetch-suggestions="querySearch" v-model="quantinputValue" ref="quantsaveTagInput">
                    <!-- <template v-if="quantnoData" slot-scope="{ item }">
                        <div class="default">{{ item.default }}</div>
                      </template> -->
                  </el-autocomplete>
                  <!-- <el-button v-else class="button-new-tag" size="small" @click="showInput" type="primary" plain>+ New Taget</el-button> -->
                  <el-tooltip class="item" effect="dark" content="If there are more than 1 targeting specialists for this project, you can add them all here." placement="right">
                    <i class="el-icon-info"></i>
                  </el-tooltip>

                </div>

              </el-form-item>
              <!-- loi -->
              <el-form-item label="LOI" prop="quantloi">
                <el-select v-model="quant.loi" placeholder="Please select LOI" @change="copy">
                  <el-option v-for="item in quantLOI" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <!-- <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                  <i class="el-icon-info"></i>
                </el-tooltip> -->
              </el-form-item>
              <!-- ir -->
              <el-form-item label="IR" prop="quantir">
                <el-select v-model="quant.ir" placeholder="Please select IR" @change="copy">
                  <el-option v-for="item in irlist" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <el-tooltip class="item" effect="dark" content="If you are not confirm the IR , please assume IR 31-59%" placement="right">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </el-form-item>
              <!-- n -->
              <!-- <el-form-item label="N">
                <el-input v-model="quant.n" placeholder="Please enter the Number"></el-input>
              </el-form-item> -->
            </el-form>
          </div>

        </div>

        <!-- 定性 -->
        <div class="qual" v-show="qualvisible">
          <div class="form">
            <el-tag type="success" class="title">Qualitative</el-tag>

            <span class="copy" v-if="form.resource==3">
              <el-checkbox v-model="tagradio" @change="copy">Copy from Quant</el-checkbox>
            </span>
            <div class="method">Method: TDI/ Web TDI</div>
            <el-form :rules="qualrules" ref="qual" :model="qual" label-width="80px" label-position="left">
              <!-- market -->
              <!-- <el-form-item label="Market" prop="qualmarket">
                <el-select v-model="qual.market" multiple placeholder="Add a Market" @change="change($event)">
                  <el-option v-for="item in marketlist" :key="item.id" :label="item.nameEN" :value="item.id">
                  </el-option>
                </el-select>
                <el-tooltip class="item" effect="dark" content="If there are more than 1 market for this project, you can add them all here." placement="right">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </el-form-item> -->
              <!-- market -->
              <el-form-item label="Market" prop="qualmarket">
                <div>
                  <div v-for="(tag,index) in qualMarketdynamicTags">
                    <el-tag type="success" closable :disable-transitions="false" @close="quanlMarkethandleClose(tag)">
                      {{tag.value}}
                    </el-tag>
                  </div>
                  <div>
                    <el-autocomplete placeholder="Add a Target" class="input-new-tag" :trigger-on-focus="true" @select="qualMarkethandleInputConfirm" @keyup.enter.native="noqualMarkethandleInputConfirm" :fetch-suggestions="qualMarketquerySearch" v-model="qualMarketinputValue" ref="qualsaveTagInput">
                    </el-autocomplete>
                    <el-tooltip class="item" effect="dark" content="If there are more than 1 market for this project, you can add them all here." placement="right">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-form-item>
              <!-- target -->
              <el-form-item label="Target" prop="qualtarget">
                <div>
                  <div v-for="(tag,index) in qualdynamicTags" :key="index+'qt'">
                    <el-tag type="success" closable :disable-transitions="false" @close="qualhandleClose(tag)">
                      {{tag.value}}
                    </el-tag>
                  </div>
                  <div>
                    <el-autocomplete placeholder="Add a Target" class="input-new-tag" :trigger-on-focus="true" @select="qualhandleInputConfirm" @keyup.enter.native="noqualhandleInputConfirm" :fetch-suggestions="qualquerySearch" v-model="qualinputValue" ref="qualsaveTagInput">
                      <!-- <template v-if="qualnoData" slot-scope="{ item }">
                        <div class="default">{{ item.default }}</div>
                      </template> -->
                    </el-autocomplete>
                    <!-- <el-button v-else class="button-new-tag" size="small" @click="qualshowInput" type="success" plain>+ New Taget</el-button> -->

                    <!-- <div v-if="form.resource==3">
                      <el-checkbox v-model="tagradio">Same as Quant</el-checkbox>
                    </div> -->
                    <el-tooltip class="item" effect="dark" content="If there are more than 1 targeting specialists for this project, you can add them all here." placement="right">
                      <i class="el-icon-info"></i>
                    </el-tooltip>
                  </div>
                </div>
              </el-form-item>
              <!-- loi -->
              <el-form-item label="LOI" prop="qualloi">
                <el-select v-model="qual.loi" placeholder="Please select LOI">
                  <el-option v-for="item in qualLOI" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <!-- <el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                  <i class="el-icon-info"></i>
                </el-tooltip> -->
              </el-form-item>
              <!-- ir -->
              <el-form-item label="IR" prop="qualir">
                <el-select v-model="qual.ir" placeholder="Please select IR">
                  <el-option v-for="item in irlist" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
                <el-tooltip class="item" effect="dark" content="If you are not confirm the IR , please assume IR 31-59%" placement="right">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </el-form-item>
              <!-- n -->
              <!-- <el-form-item label="N">
                <el-input v-model="qual.n" placeholder="Please enter the Number"></el-input>
              </el-form-item> -->
              <div style="font-family:Verdana;font-weight:700;font-size: 0.875rem;color: #606266;">Services Required</div>
              <el-form-item label="">

                <div>
                  <el-checkbox v-model="sever.moderator">Moderator</el-checkbox>
                </div>
                <div>
                  <el-checkbox v-model="sever.moderatorBrief">Moderator Brief (1 hour)</el-checkbox>
                </div>
                <div>
                  <el-checkbox v-model="sever.moderatorDebrief">Moderator Debrief (1 hour)</el-checkbox>
                </div>
                <div>
                  <el-checkbox v-model="sever.translationMaterials">Screener & DG translation (about 20 pages)</el-checkbox>
                </div>
                <div>
                  <el-checkbox v-model="sever.translationSimultaneous">Simultaneous Interpretation (local language - English)</el-checkbox>
                </div>
                <div>
                  <el-checkbox v-model="sever.transcriptInEnglish" :disabled="sever.transcriptInEnglishRush">English Transcript</el-checkbox>
                </div>
                <!-- <div>
                  <el-checkbox v-model="sever.transcriptInEnglishRush" :disabled="sever.transcriptInEnglish">English Transcript (rush - 3 days)</el-checkbox>
                </div> -->
                <div>
                  <el-checkbox v-model="sever.englishCa" :disabled="sever.englishCaRush">English CA</el-checkbox>
                </div>
                <!-- <div>
                  <el-checkbox v-model="sever.englishCaRush" :disabled="sever.englishCa">English CA Rush (4 days)</el-checkbox>
                </div> -->

                <div>
                  <el-checkbox v-model="sever.topLineReportInEnglish">Top Line Report In English (Excel/Word)</el-checkbox>
                </div>
                <div>
                  <el-checkbox v-model="sever.summaryReportInEnglish">Summary Report In English (PPT 20 pages)</el-checkbox>
                </div>
                <div>
                  <el-checkbox v-model="sever.fullReportInEnglish">Full Report In English (PPT 60 pages)</el-checkbox>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="button">
        <el-button type="primary" @click="next">Next</el-button>
        <!-- <el-button type="primary" @click="dialogVisible1=true">有未填写的</el-button> -->

      </div>
    </div>
    <el-dialog title="prompt message" :visible.sync="dialogVisible1" width="30%">
      <span>You have information left unfilled</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogVisible1 = false">OK</el-button>
      </span>
    </el-dialog>
    <el-dialog title="prompt message" :visible.sync="dialogVisible2" width="30%">
      <span>Please fill in Total sample size per market</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogVisible2 = false">OK</el-button>
      </span>
    </el-dialog>
    <div class="dialog">
      <el-dialog title="Please confirm the information and input sample size per market" :visible.sync="dialogVisible" width="90%">
        <div class="table">
          <div v-if="quantvisible">
            <el-tag class="title">Quantitative</el-tag>

            <div class="quanttable">

              <table>
                <tr>
                  <td class="label">Market</td>
                  <td v-for="item in diaquantmarket" class="details">{{item}}</td>
                </tr>
                <tr>
                  <td class="label">Target</td>
                  <td :colspan="diaquantmarket.length" class="details">
                    <div v-for="item in quantdynamicTags">{{item.value}}</div>

                  </td>
                </tr>
                <tr>
                  <td class="label">LOI</td>
                  <td :colspan="diaquantmarket.length" class="details">{{diaquantloi}}</td>
                </tr>
                <tr>
                  <td class="label">IR</td>
                  <td :colspan="diaquantmarket.length" class="details">{{diaquantir}}</td>
                </tr>
                <tr>
                  <td class="label">Total sample size per market</td>
                  <td v-for="(item,index) in list">
                    <el-input v-model="item.number" placeholder="Please enter sample size" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div v-if="qualvisible">
            <el-tag type="success" class="title">Qualitative</el-tag>

            <div class="qualtable">

              <table>
                <tr>
                  <td class="label">Market:</td>
                  <td v-for="item in diaqualmarket" class="details">{{item}}</td>
                </tr>
                <tr>
                  <td class="label">Target</td>
                  <td :colspan="diaqualmarket.length" class="details">
                    <div v-for="item in qualdynamicTags">{{item.value}}</div>
                  </td>
                </tr>
                <tr>
                  <td class="label">LOI</td>
                  <td :colspan="diaqualmarket.length" class="details">{{diaqualloi}}</td>
                </tr>
                <tr>
                  <td class="label">IR</td>
                  <td :colspan="diaqualmarket.length" class="details">{{diaqualir}}</td>
                </tr>
                <tr>
                  <td class="label">Total sample size per market</td>
                  <td v-for="(item,index) in quallist">
                    <el-input v-model="item.number" placeholder="Please enter sample size" oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
                  </td>
                </tr>
                <tr>
                  <td class="label">Need Services</td>
                  <td :colspan="diaqualmarket.length" class="details">
                    <div v-for="item in needservice">{{item}}</div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">Back</el-button>
          <el-button type="primary" @click="getQuote()">Get Quote</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { advertisementFlow, getQuotationList, removeRedisValue, getMarketsList, getTargetList, getIrList, getQuantitativeLoiList, getQualitativeLoiList, editQuotation, getQuotationClientList } from "@/api/api";
export default {
  data() {
    // const quantmarket = (rule, value, callback) => {
    //   if (this.quant.market.length <= 0) {
    //     return callback(new Error("Please complete this required field"));
    //   } else {
    //     callback();
    //   }
    // };
    const quanttarget = (rules, value, callback) => {
      setTimeout(() => {
        if (this.quantdynamicTags.length < 1) {
          return callback(new Error("Please complete this required field"));
        } else {
          callback();
        }
      }, 200);
    };
    const quantmarket = (rules, value, callback) => {
      setTimeout(() => {
        if (this.quantMarketdynamicTags.length < 1) {
          return callback(new Error("Please complete this required field"));
        } else {
          callback();
        }
      }, 200);
    };
    const quantloi = (rules, value, callback) => {
      if (this.quant.loi == "") {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    const quantir = (rules, value, callback) => {
      if (this.quant.ir == "") {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    const name = (rules, value, callback) => {
      if (value == "") {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    const qualmarket = (rule, value, callback) => {
      if (this.qualMarketdynamicTags.length <= 0) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    const qualtarget = (rules, value, callback) => {
      setTimeout(() => {
        if (this.qualdynamicTags.length < 1) {
          return callback(new Error("Please complete this required field"));
        } else {
          callback();
        }
      }, 200);
    };
    const qualloi = (rules, value, callback) => {
      if (this.qual.loi == "") {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    const qualir = (rules, value, callback) => {
      if (this.qual.ir == "") {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    const number = (rules, value, callback) => {
      if (value == "") {
        return callback(new Error("Please complete this required field"));
      } else if (value.typeof() != Number) {
        return callback(new Error("Please enter the number"));
      } else {
        callback();
      }
    };
    return {
      logOutdialogVisible:false,
      pageIndex: 1,
      pageSize: 8,
      allCount: 0,
      historydialogVisible: false,
      loading: false,
      disabled: false,
      clientList: [],
      sever: {
        moderator: false,
        moderatorBrief: false,
        translationMaterials: false,
        translationSimultaneous: false,
        transcriptInEnglish: false,
        transcriptInEnglishRush: false,
        englishCa: false,
        moderatorDebrief: false,
        englishCaRush: false,
        topLineReportInEnglish: false,
        summaryReportInEnglish: false,
        fullReportInEnglish: false
      },
      needservice: [],
      tagradio: false,
      dialogVisible1: false,
      dialogVisible: false,
      dialogVisible2: false,
      qualvisible: true,
      quantvisible: true,
      form: {
        name: "",
        resource: 3,
        client: ""
      },
      quant: {
        market: [],
        loi: "",
        ir: "",
        n: ""
      },
      qual: {
        market: [],
        loi: "",
        ir: "",
        n: ""
      },
      //   market
      //marketlist: [],

      // qualmarketlist: [],
      //   target
      quantrestaurants: [],
      quantdynamicTags: [],
      quantinputVisible: false,
      quantinputValue: "",
      qualrestaurants: [],
      qualdynamicTags: [],
      qualinputVisible: false,
      qualinputValue: "",
      // 1.设置变量
      marketlist: [],
      quantMarketdynamicTags: [],
      quantMarketinputVisible: false,
      quantMarketinputValue: "",
      qualmarketlist: [],
      qualMarketdynamicTags: [],
      qualMarketinputVisible: false,
      qualMarketinputValue: "",
      // ir
      irlist: [],
      // qualirlist: [],

      // loi
      quantLOI: [],
      qualLOI: [],
      //   弹框内容
      diaquantmarket: [],
      diaquanttag: [],
      diaquantloi: "",
      diaquantir: "",
      diaqualmarket: [],
      diaqualtag: [],
      diaqualloi: "",
      diaqualir: "",
      HistoryList: [], //历史列表
      list: [],
      quallist: [],

      quantvalid: false,
      qualvalid: false,
      formvalid: false,
      rules: {
        quantmarket: [{ validator: quantmarket, trigger: "change" }],
        quanttarget: [{ validator: quanttarget, trigger: "change" }],
        quantloi: [{ validator: quantloi, trigger: "change" }],
        quantir: [{ validator: quantir, trigger: "change" }]
      },
      formrules: {
        name: [{ validator: name, trigger: "blur" }]
      },
      qualrules: {
        qualmarket: [{ validator: qualmarket, trigger: "change" }],
        qualtarget: [{ validator: qualtarget, trigger: "change" }],
        qualloi: [{ validator: qualloi, trigger: "change" }],
        qualir: [{ validator: qualir, trigger: "change" }]
      },
      number: [{ validator: number, trigger: "blur" }]
    };
  },
  created() {
    this.getMarketsList();
    this.getTargetList();
    this.getIrList();
    this.getQuantitativeLoiList();
    this.getQualitativeLoiList();
    // this.show();
    this.sure();
    // this.removeRedisValue();
    this.iscookies();
    this.getQuotationClientList();
    this.getQuotationList(1);
  },
  mounted() {
    this.quantdynamicTags = [...new Set(this.quantdynamicTags)];
    this.qualdynamicTags = [...new Set(this.qualdynamicTags)];
    this.quantMarketdynamicTags = [...new Set(this.quantMarketdynamicTags)];
    this.qualMarketdynamicTags = [...new Set(this.qualMarketdynamicTags)];

    // console.log(this.quant.market);
  },
  methods: {
       // 登出
    Logout() {
      localStorage.removeItem("logincookies");
      this.$router.push({ name: "equote", query: { source: "logout" } });
      this.dialogVisible = false;
    },
    // 获取历史列表
    getQuotationList(val) {
      this.pageIndex = val;
      this.loading = true;
      getQuotationList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        quotation: JSON.parse(localStorage.getItem("quotation"))
      }).then(res => {
        this.HistoryList = res.datalist;
        this.allCount = res.allCount;
        this.loading = false;
      });
    },
    // 获取公司列表
    getQuotationClientList() {
      getQuotationClientList().then(res => {
        this.clientList = res;
        this.clientList.forEach(item => {
          if (item.id == localStorage.getItem("login")) {
            this.form.client = item.id;
          }
        });
      });
      if (localStorage.getItem("isHolden") == "false") {
        this.disabled = true;
      }
    },
    copy() {
      if (this.tagradio == true) {
        // this.qual.market = this.quant.market;
        this.qual.ir = this.quant.ir;
        // this.qual.loi = this.quant.loi;
        this.quantdynamicTags.forEach(item => {
          this.qualdynamicTags.push(item);
          this.qualdynamicTags = [...new Set(this.qualdynamicTags)];
        });
        this.quantMarketdynamicTags.forEach(item => {
          this.qualMarketdynamicTags.push(item);
          this.qualMarketdynamicTags = [...new Set(this.qualMarketdynamicTags)];
        });
        setTimeout(() => {
          if (this.qualdynamicTags != "") {
            this.$refs.qual.validateField("qualtarget", valid => {
              if (valid) {
              }
            });
          }
          if (this.qualMarketdynamicTags != "") {
            this.$refs.qual.validateField("qualmarket", valid => {
              if (valid) {
              }
            });
          }
        }, 200);
      } else {
        // console.log(this.qual);
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "table",
          source: "",
          information: "询价页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
            // console.log(source);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "table",
          source: this.$route.query.source,
          information: "询价页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
            // console.log(source);
          }
        });
      }
    },
    // 检测是否登录过，然后跳转
    iscookies() {
      // 如果登录过,看看过期没有，过期了要删除
      if (localStorage.getItem("logincookies")) {
        var val = localStorage.getItem("logincookies");
        var dataobj = JSON.parse(val);

        var newTime = new Date().getTime();
        if (newTime - dataobj.time > 21600000) {
          localStorage.removeItem("logincookies");
        }
      }
      if (!localStorage.getItem("logincookies")) {
        this.$router.push({ name: "equote", query: { source: "nologin" } });
      }
    },
    change(value) {},
    // 报价
    getQuote() {
      // 第二步,设置好数据
      var quantForm = {
        irLever: this.quant.ir,
        list: this.list,
        loi: this.quant.loi,
        target: this.quantdynamicTags
      };
      var qualForm = {
        irLever: this.qual.ir,
        list: this.quallist,
        loi: this.qual.loi,
        target: this.qualdynamicTags,
        moderator: this.sever.moderator,
        moderatorBrief: this.sever.moderatorBrief,
        translationMaterials: this.sever.translationMaterials,
        translationSimultaneous: this.sever.translationSimultaneous,
        transcriptInEnglish: this.sever.transcriptInEnglish,
        transcriptInEnglishRush: this.sever.transcriptInEnglishRush,
        englishCa: this.sever.englishCa,
        englishCaRush: this.sever.englishCaRush,
        topLineReportInEnglish: this.sever.topLineReportInEnglish,
        moderatorDebrief: this.sever.moderatorDebrief,

        summaryReportInEnglish: this.sever.summaryReportInEnglish,
        fullReportInEnglish: this.sever.fullReportInEnglish
      };
      var quantnumber = false;
      var qualnumber = false;
      this.list.forEach(item => {
        if (item.number == "") {
          quantnumber = true;
        }
      });
      this.quallist.forEach(item => {
        if (item.number == "") {
          qualnumber = true;
        }
      });
      //   第二步，进行报价
      if (this.form.resource == 1) {
        qualForm = null;
        // this.list.forEach(item => {
        if (quantnumber == true) {
          this.dialogVisible2 = true;
        } else {
          editQuotation({
            client: this.$route.query.client,
            projectName: this.form.name,
            optionUser: this.form.client,
            qualitative: qualForm,
            quantitative: quantForm,
            quotation: JSON.parse(localStorage.getItem("quotation"))
          }).then(res => {
            var id = res.specialmsg;
            localStorage.setItem("projectname", JSON.stringify(this.form.name));
            var client = this.$route.query.client;
            if (this.$route.query.client == undefined) {
              client = JSON.parse(localStorage.getItem("login"));
            }
            this.$router.push({ name: "RFQ", query: { id: id, client: client, source: "table" } });
          });
          // this.dialogVisible = false;
        }
        // });
      } else if (this.form.resource == 2) {
        quantForm = null;
        // this.quallist.forEach(item => {
        if (qualnumber == true) {
          this.dialogVisible2 = true;
        } else {
          editQuotation({
            client: this.$route.query.client,
            projectName: this.form.name,
            optionUser: this.form.client,
            qualitative: qualForm,
            quantitative: quantForm,
            quotation: JSON.parse(localStorage.getItem("quotation"))
          }).then(res => {
            var id = res.specialmsg;
            localStorage.setItem("projectname", JSON.stringify(this.form.name));
            var client = this.$route.query.client;
            if (this.$route.query.client == undefined) {
              client = JSON.parse(localStorage.getItem("login"));
            }
            this.$router.push({ name: "RFQ", query: { id: id, client: client, source: "table" } });
          });
          // this.dialogVisible = false;
        }
        // });
      } else if (this.form.resource == 3) {
        if (quantnumber == true || qualnumber == true) {
          console.log(quantnumber);
          console.log(qualnumber);
          this.dialogVisible2 = true;
        } else {
          editQuotation({
            client: this.$route.query.client,
            projectName: this.form.name,
            optionUser: this.form.client,
            qualitative: qualForm,
            quantitative: quantForm,
            quotation: JSON.parse(localStorage.getItem("quotation"))
          }).then(res => {
            var id = res.specialmsg;
            localStorage.setItem("projectname", JSON.stringify(this.form.name));
            var client = this.$route.query.client;
            if (this.$route.query.client == undefined) {
              client = JSON.parse(localStorage.getItem("login"));
            }
            this.$router.push({ name: "RFQ", query: { id: id, client: client, source: "table" } });
          });
          // this.dialogVisible = false;
        }
      }
      // editQuotation({
      //     client: this.$route.query.client,
      //     projectName: this.form.name,
      //     qualitative: qualForm,
      //     quantitative: quantForm,
      //     quotation: JSON.parse(localStorage.getItem("quotation"))
      //   }).then(res => {
      //     var id = res.specialmsg;
      //     localStorage.setItem("projectname", JSON.stringify(this.form.name));
      //     var client = this.$route.query.client;
      //     if (this.$route.query.client == undefined) {
      //       client = JSON.parse(localStorage.getItem("login"));
      //     }
      //     this.$router.push({ name: "RFQ", query: { id: id, client: client, source: "table" } });
      //   });
      //   this.dialogVisible = false;
    },
    // 确认页面的内容安排
    sure() {},
    // 下一步
    next() {
      this.quantvalid = false;
      this.qualvalid = false;
      this.formvalid = false;
      this.$refs.quant.validate(valid => {
        if (valid) {
          this.quantvalid = true;
        } else {
        }
      });
      this.$refs.qual.validate(valid => {
        if (valid) {
          this.qualvalid = true;
        } else {
        }
      });
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formvalid = true;
        } else {
        }
      });
      setTimeout(() => {
        if (this.form.resource == 1) {
          if (this.quantvalid == true && this.formvalid == true) {
            this.dialogVisible = true;
          } else {
            this.dialogVisible1 = true;
          }
        }
        if (this.form.resource == 2) {
          if (this.qualvalid == true && this.formvalid == true) {
            this.dialogVisible = true;
          } else {
            this.dialogVisible1 = true;
          }
        }
        if (this.form.resource == 3) {
          if (this.qualvalid == true && this.quantvalid == true && this.formvalid == true) {
            this.dialogVisible = true;
          } else {
            this.dialogVisible1 = true;
          }
        }
      }, 300);

      // 定量的市场
      this.diaquantmarket = [];
      this.quantMarketdynamicTags.forEach(item => {
        this.marketlist.forEach(market => {
          if (item.id == market.id) {
            this.diaquantmarket.push(market.nameEN);
            this.diaquantmarket = [...new Set(this.diaquantmarket)];
          }
        });
      });
      // 定量的tag
      // this.diaquanttag = this.quantdynamicTags;
      // 定量的loi
      this.quantLOI.forEach(item => {
        if (item.id == this.quant.loi) {
          this.diaquantloi = item.name;
        }
      });
      // 定量的ir
      this.irlist.forEach(item => {
        if (item.id == this.quant.ir) {
          this.diaquantir = item.name;
        }
      });
      //   定性市场

      this.diaqualmarket = [];
      this.qualMarketdynamicTags.forEach(item => {
        this.marketlist.forEach(market => {
          if (item.id == market.id) {
            this.diaqualmarket.push(market.nameEN);
            this.diaqualmarket = [...new Set(this.diaqualmarket)];
          }
        });
      });
      this.list = [];
      this.quallist = [];
      this.quantMarketdynamicTags.forEach(item => {
        this.list.push({ market: item.id, number: this.quant.n });
      });
      // console.log(this.list);
      this.qualMarketdynamicTags.forEach(item => {
        this.quallist.push({ market: item.id, number: this.qual.n });
      });
      // this.diaqualtag = this.qualdynamicTags;
      // 定性的loi
      this.qualLOI.forEach(item => {
        if (item.id == this.qual.loi) {
          this.diaqualloi = item.name;
        }
      });
      // 定性的ir
      this.irlist.forEach(item => {
        if (item.id == this.qual.ir) {
          this.diaqualir = item.name;
        }
      });
      // 定性的服务
      this.needservice = [];
      for (var k in this.sever) {
        if (this.sever[k] == true) {
          if (k == "moderator") {
            this.needservice.push("Moderator");
          }
          if (k == "moderatorBrief") {
            this.needservice.push("Moderator Brief (1 hour)");
          }
          if (k == "translationMaterials") {
            this.needservice.push("Screener & DG translation (about 20 pages)");
          }
          if (k == "translationSimultaneous") {
            this.needservice.push("Simultaneous Interpretation (local language - English)");
          }
          if (k == "transcriptInEnglish") {
            this.needservice.push("English Transcript");
          }
          if (k == "transcriptInEnglishRush") {
            this.needservice.push("English Transcript (rush - 3 days)");
          }
          if (k == "englishCa") {
            this.needservice.push("English CA");
          }
          if (k == "englishCaRush") {
            this.needservice.push("English CA Rush (4 days)");
          }
          if (k == "topLineReportInEnglish") {
            this.needservice.push("Top Line Report In English (Excel/Word)");
          }
          if (k == "moderatorDebrief") {
            this.needservice.push("Moderator Debrief (1 hour)");
          }
          if (k == "summaryReportInEnglish") {
            this.needservice.push("Summary Report In English (PPT 20 pages)");
          }
          if (k == "fullReportInEnglish") {
            this.needservice.push("Full Report In English (PPT 60 pages)");
          }
        }
      }
      // 弹框
      // if (this.form.resource == 1) {
      //   if (this.form.name == "" || this.quant.market == "" || this.quantdynamicTags == "" || this.quant.loi == "" || this.quant.ir == "" || this.quant.n == "") {
      //     this.dialogVisible1 = true;
      //   } else {
      //     this.dialogVisible = true;
      //   }
      // } else if (this.form.resource == 2) {
      //   if (this.form.name == "" || this.qual.market == "" || this.qualdynamicTags == "" || this.qual.loi == "" || this.qual.ir == "" || this.qual.n == "") {
      //     this.dialogVisible1 = true;
      //   } else {
      //     this.dialogVisible = true;
      //   }
      // } else if (this.form.resource == 3) {
      //   if (this.form.name == "" || this.qual.market == "" || this.diaqualtag.length <= 0 || this.qual.loi == "" || this.qual.ir.length <= 0 || this.qual.n == "" || this.quant.market == "" || this.quantdynamicTags == "" || this.quant.loi == "" || this.quant.ir == "" || this.quant.n == "") {
      //     this.dialogVisible1 = true;
      //   } else {
      //     this.dialogVisible = true;
      //   }
      // }
    },
    // 单选变动时
    show() {
      if (this.form.resource == 1) {
        this.quantvisible = true;
        this.qualvisible = false;
      } else if (this.form.resource == 2) {
        this.qualvisible = true;
        this.quantvisible = false;
      } else if (this.form.resource == 3) {
        this.qualvisible = true;
        this.quantvisible = true;
      }
      // this.getMarketsList();
      // this.getIrList();
    },
    // 获取定量loi
    getQuantitativeLoiList() {
      getQuantitativeLoiList({}).then(res => {
        this.quantLOI = res;
      });
    },
    // 获取定性loi
    getQualitativeLoiList() {
      getQualitativeLoiList({}).then(res => {
        this.qualLOI = res;
      });
    },
    // 获取ir
    getIrList() {
      getIrList({}).then(res => {
        this.irlist = res;
      });
    },
    // 获取target
    getTargetList() {
      getTargetList({}).then(res => {
        // 吧list赋值给quantrestaurants，内包含value和id
        this.quantrestaurants = res;
        this.qualrestaurants = res;
      });
    },
    // 获取market
    getMarketsList() {
      getMarketsList({}).then(res => {
        this.marketlist = res.datalist;
      });
    },
    handleClose(tag) {
      this.quantdynamicTags.splice(this.quantdynamicTags.indexOf(tag), 1);
    },
    qualhandleClose(tag) {
      this.qualdynamicTags.splice(this.qualdynamicTags.indexOf(tag), 1);
    },
    quantMarkethandleClose(tag) {
      this.quantMarketdynamicTags.splice(this.quantMarketdynamicTags.indexOf(tag), 1);
      // console.log(this.quantMarketdynamicTags);
    },
    quanlMarkethandleClose(tag) {
      this.qualMarketdynamicTags.splice(this.qualMarketdynamicTags.indexOf(tag), 1);
    },
    showInput() {
      this.quantinputVisible = true;
      this.$nextTick(_ => {
        this.$refs.quantsaveTagInput.$refs.input.focus();
      });
    },
    qualshowInput() {
      this.qualinputVisible = true;
      this.$nextTick(_ => {
        this.$refs.qualsaveTagInput.$refs.input.focus();
      });
    },
    // 定量target
    nohandleInputConfirm() {
      let quantinputValue = this.quantinputValue;
      if (quantinputValue) {
        this.quantdynamicTags.push({ value: quantinputValue });
      }
      this.quantinputVisible = false;
      this.quantinputValue = "";
    },
    handleInputConfirm(item) {
      if (item) {
        // 由于点击时将内容变成inputvalue。所以pushinputvalue就只有内容，没有id
        // 变成item就有id了
        this.quantdynamicTags.push(item);
        // 不能重复
        this.quantdynamicTags = [...new Set(this.quantdynamicTags)];
        setTimeout(() => {
          if (this.quantdynamicTags != "") {
            this.$refs.quant.validateField("quanttarget", valid => {
              if (valid) {
              }
            });
          }
        }, 200);
        // 如果要copy的话，就把内容塞到定性里面
        if (this.tagradio == true) {
          this.quantdynamicTags.forEach(item => {
            this.qualdynamicTags.push(item);
            this.qualdynamicTags = [...new Set(this.qualdynamicTags)];
          });
          setTimeout(() => {
            if (this.qualdynamicTags != "") {
              this.$refs.qual.validateField("qualtarget", valid => {
                if (valid) {
                }
              });
            }
          }, 200);
        }
      }

      this.quantinputVisible = false;
      this.quantinputValue = "";
    },
    // 定量market
    noMarkethandleInputConfirm() {
      let quantMarketinputValue = this.quantMarketinputValue;
      if (quantMarketinputValue) {
        this.quantMarketdynamicTags.push({ value: quantMarketinputValue });
      }
      this.quantMarketinputVisible = false;
      this.quantMarketinputValue = "";
    },
    MarkethandleInputConfirm(item) {
      if (item) {
        // 由于点击时将内容变成inputvalue。所以pushinputvalue就只有内容，没有id
        // 变成item就有id了
        this.quantMarketdynamicTags.push(item);
        // 不能重复
        this.quantMarketdynamicTags = [...new Set(this.quantMarketdynamicTags)];
        setTimeout(() => {
          if (this.quantMarketdynamicTags != "") {
            this.$refs.quant.validateField("quantmarket", valid => {
              if (valid) {
              }
            });
          }
        }, 200);
        if (this.tagradio == true) {
          this.quantMarketdynamicTags.forEach(item => {
            // 这里在后面改完之后记得改
            this.qualMarketdynamicTags.push(item);
            this.qualMarketdynamicTags = [...new Set(this.qualMarketdynamicTags)];
          });
          setTimeout(() => {
            if (this.qualMarketdynamicTags != "") {
              this.$refs.qual.validateField("qualmarket", valid => {
                if (valid) {
                }
              });
            }
          }, 200);
        }
      }

      this.quantMarketinputVisible = false;
      this.quantMarketinputValue = "";
    },
    // 定性target
    noqualhandleInputConfirm() {
      let qualinputValue = this.qualinputValue;
      if (qualinputValue) {
        this.qualdynamicTags.push({ value: qualinputValue });
      }
      this.qualinputVisible = false;
      this.qualinputValue = "";
      //   console.log(this.qualdynamicTags);
    },
    qualhandleInputConfirm(item) {
      if (item) {
        this.qualdynamicTags.push(item);
        this.qualdynamicTags = [...new Set(this.qualdynamicTags)];
        setTimeout(() => {
          if (this.qualdynamicTags != "") {
            this.$refs.qual.validateField("qualtarget", valid => {
              if (valid) {
              }
            });
          }
        }, 200);
      }

      this.qualinputVisible = false;
      this.qualinputValue = "";
    },

    // 定性market
    noqualMarkethandleInputConfirm() {
      let qualMarketinputValue = this.qualMarketinputValue;
      if (qualMarketinputValue) {
        this.qualMarketdynamicTags.push({ value: qualMarketinputValue });
      }
      this.qualMarketinputVisible = false;
      this.qualMarketinputValue = "";
      //   console.log(this.qualdynamicTags);
    },
    qualMarkethandleInputConfirm(item) {
      if (item) {
        this.qualMarketdynamicTags.push(item);
        this.qualMarketdynamicTags = [...new Set(this.qualMarketdynamicTags)];
        setTimeout(() => {
          if (this.qualMarketdynamicTags != "") {
            this.$refs.qual.validateField("qualmarket", valid => {
              if (valid) {
              }
            });
          }
        }, 200);
      }

      this.qualMarketinputVisible = false;
      this.qualMarketinputValue = "";
    },
    querySearch(queryString, cb) {
      // 获取符合规定的list
      var quantrestaurants = this.quantrestaurants;
      // 如果有输入的文字，就执行筛选，没有就是没有
      var results = queryString ? quantrestaurants.filter(this.createFilter(queryString)) : quantrestaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    MarketquerySearch(queryString, cb) {
      // 获取符合规定的list
      var marketlist = this.marketlist;
      // 如果有输入的文字，就执行筛选，没有就是没有
      var Marketresults = queryString ? marketlist.filter(this.MarketcreateFilter(queryString)) : marketlist;
      // 调用 callback 返回建议列表的数据
      cb(Marketresults);
    },
    qualquerySearch(queryString, cb) {
      var qualrestaurants = this.qualrestaurants;
      var qualresults = queryString ? qualrestaurants.filter(this.qualcreateFilter(queryString)) : qualrestaurants;
      // 调用 callback 返回建议列表的数据
      cb(qualresults);
    },
    qualMarketquerySearch(queryString, cb) {
      var marketlist = this.marketlist;
      var qualMarketresults = queryString ? marketlist.filter(this.qualMarketcreateFilter(queryString)) : marketlist;
      // 调用 callback 返回建议列表的数据
      cb(qualMarketresults);
    },
    createFilter(queryString) {
      return quantrestaurant => {
        return quantrestaurant.value.toLowerCase().match(queryString.toLowerCase());
      };
    },
    MarketcreateFilter(queryString) {
      return quantMarketrestaurant => {
        return quantMarketrestaurant.value.toLowerCase().match(queryString.toLowerCase());
      };
    },
    qualcreateFilter(queryString) {
      return qualrestaurant => {
        return qualrestaurant.value.toLowerCase().match(queryString.toLowerCase());
      };
    },
    qualMarketcreateFilter(queryString) {
      return qualMarketresult => {
        return qualMarketresult.value.toLowerCase().match(queryString.toLowerCase());
      };
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  font-size: 16px;
}
/deep/.el-textarea__inner {
  min-height: 40.3333px !important;
}
.item {
  margin-left: 10px;
}
/deep/.el-form {
  margin: 0 auto;
  .el-scrollbar__wrap {
    overflow: scroll;
  }
  // width: auto;
  .el-input {
    width: 320px;
  }
  .el-textarea {
    width: 300px;
  }
  .el-input__inner {
    // font-size: 15px;
    // width: 100%;
    // height: 100%;
  }
}
.projectform {
  // width: 550px;
  display: flex;
  margin: 50px auto 30px;
}
.information {
  display: flex;
  justify-content: space-around;
  .quant,
  .qual {
    width: 50%;
    .title {
      margin-bottom: 10px;
    }
    .method {
      margin-bottom: 10px;
    }
    .form {
      width: 450px;
      margin: 0 auto !important;
    }
  }
  .copy {
    margin-left: 10px;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  //   width: 300px;
}
.input-new-tag {
  font-size: 16px;
  width: 320px;
  vertical-align: bottom;
}
.el-tag {
}
/deep/.el-checkbox__label {
  font-size: 16px;
  margin: 5px 0;
}
.button {
  text-align: center;
  padding: 20px;
}
.dialog {
  td {
    border: 1px solid #000;
    padding: 10px;
  }
  .details {
    min-width: 200px;
    text-align: center;
  }

  .table {
    // display: flex;
  }
  .title {
    margin-bottom: 10px;
  }
  .quanttable,
  .qualtable {
    overflow-x: auto;
    margin: 10px;
    .label {
      min-width: 260px;
    }
    .el-input {
      // width: 200px;
    }
    /deep/.el-input__inner {
      text-align: center;
      padding: 0;
      border: 1px solid #217df6;
    }
    // display: flex;
    // justify-content: center;
  }
  // .overflow {
  //   justify-content: start;
  //   overflow-x: auto;
  //   .label {
  //     min-width: 230px;
  //   }
  // }
  /deep/.dialog-footer {
    display: flex;
    justify-content: center;
  }
}
/deep/.el-form-item__error {
  font-size: 12px !important;
}
.company {
  /deep/.el-form-item__content {
    margin: 0 !important;
  }
}

/deep/.el-radio__inner {
  border: 1px solid rgb(199, 180, 180);
}
.history {
  text-align: right;
  margin: 10px 100px;
}
</style>